export default {"src":"/_next/static/media/vector.28322794.svg","height":11,"width":21,"blurWidth":0,"blurHeight":0};